import { Tooltip, TooltipProps } from 'lego-on-react';
import React, { useRef, useState } from 'react';

interface WithTooltipProps extends TooltipProps {
    tooltipChildren: React.ReactNode;
    className?: string;
    disabled: boolean;
}

export const WithTooltip: React.FC<WithTooltipProps> = ({
    tooltipChildren,
    children,
    className,
    onOutsideClick,
    disabled,
    ...tooltipProps
}) => {
    const [isTooltipVisible, setTooltipVisibility] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);

    if (disabled) {
        return <>{children}</>;
    }

    const showTooltip = () => !isTooltipVisible && setTooltipVisibility(true);
    const hideTooltip = () => isTooltipVisible && setTooltipVisibility(false);

    return (
        <>
            <div className={className} ref={wrapperRef} onMouseLeave={hideTooltip} onMouseEnter={showTooltip}>
                {children}
            </div>
            <Tooltip
                to="top"
                anchor={wrapperRef.current!}
                visible={isTooltipVisible}
                onOutsideClick={() => {
                    onOutsideClick && onOutsideClick();
                    hideTooltip();
                }}
                autoclosable
                {...tooltipProps}
            >
                {
                    <div
                        style={{
                            wordWrap: 'break-word',
                            width: 313,
                            lineHeight: '1.5em',
                            padding: '12px 8px',
                            fontSize: '13px',
                            fontWeight: 400,
                            // backgroundColor: 'rgba(39, 39, 51, 1)'
                        }}
                    >
                        {tooltipChildren}
                    </div>
                }
            </Tooltip>
        </>
    );
};
